import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgHeart = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m11.578 5.774.39.422.422-.42a5.11 5.11 0 0 1 4.412-1.404A5.024 5.024 0 0 1 21 9.329v.204a5.26 5.26 0 0 1-1.673 3.85l-6.353 5.93a1.427 1.427 0 0 1-1.948 0l-6.353-5.93A5.26 5.26 0 0 1 3 9.532v-.204a5.025 5.025 0 0 1 4.198-4.957 5.05 5.05 0 0 1 4.38 1.402s-.031 0 0 0m.39 2.81-1.582-1.646a3.41 3.41 0 0 0-2.91-.902 3.34 3.34 0 0 0-2.788 3.293v.204c0 .991.411 1.94 1.136 2.615L12 17.914l6.177-5.766a3.58 3.58 0 0 0 1.136-2.615v-.204a3.34 3.34 0 0 0-2.788-3.293 3.41 3.41 0 0 0-2.911.902z"
    }));
export default SvgHeart;
